import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from 'rc-dropdown';
import { ButtonLabel } from 'components/Button';
import { Icon } from 'components/Icon';

import { rentStatisticSelector } from 'store/transferAct/selectors';
import { Rent } from 'store/transferAct/actions';

import { Portal } from 'components/Portal';
import { Loader } from 'components/Loader';
import { InputRangeDatePicker } from 'components/InputRangeDatePicker/InputRangeDatePicker';
import './style.scss';

const ModalStatisticReservation = ({ onClose }) => {
  const dispatch = useDispatch();

  const [calendarVisible, setCalendarVisible] = useState(false);

  const statistic = useSelector(rentStatisticSelector);

  const [pending, setPending] = useState(false);

  useEffect(() => {
    dispatch(Rent.getStatisticList());
  }, [onClose]);

  const handleFilterByDate = ({ from, to } = {}) => {
    setCalendarVisible(false);

    if (!from & !to) {
      dispatch(Rent.getStatisticList());
    } else {
      dispatch(
        Rent.getStatisticList({
          endDateTime_min: Math.round(+from / 1000),
          endDateTime_max: Math.round(+to / 1000),
        })
      );
    }
  };

  return (
    <Portal id="modal-statistic" className="reservation-statistic" onClose={onClose}>
      <div className="modal-title">
        <div className="header-title-reservation-statistic">
          <b> Статистика резервов</b>
        </div>
      </div>
      <div className="reservation-statistic-list dropdownScroll">
        {statistic && (
          <>
            <div className="reservation-statistic-select">
              <div className="reservation-statistic-data">
                <div className="reservation-statistic-name">Всего</div>{' '}
                <div>
                  : <b> {statistic.all.value.toLocaleString('ru')} шт.</b> ({statistic.all.percent}%)
                </div>
              </div>
            </div>
            <div className="reservation-statistic-select">
              <div className="reservation-statistic-data">
                <div className="reservation-statistic-name">Подтверждено</div>{' '}
                <div>
                  : <b> {statistic.approved.value.toLocaleString('ru')} шт.</b> ({statistic.approved.percent}%)
                </div>
              </div>
            </div>

            <div className="reservation-statistic-select">
              <div className="reservation-statistic-data">
                <div className="reservation-statistic-name">Просрочено</div>{' '}
                <div>
                  : <b> {statistic.expire.value.toLocaleString('ru')} шт.</b> ({statistic.expire.percent}%)
                </div>
              </div>
            </div>
            <div className="reservation-statistic-select">
              <div className="reservation-statistic-data">
                <div className="reservation-statistic-name">Отклонено</div>{' '}
                <div>
                  : <b> {statistic.not_approved.value.toLocaleString('ru')} шт.</b> ({statistic.not_approved.percent}%)
                </div>
              </div>
            </div>
          </>
        )}

        {statistic === null && <Loader type="small" color="#000" />}
      </div>
      <InputRangeDatePicker
        handleFilter={handleFilterByDate}
        boxShadow={false}
        close={() => setCalendarVisible(false)}
      />
    </Portal>
  );
};

ModalStatisticReservation.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { ModalStatisticReservation };
